import type { SessionData } from "@/backend/read/BackendReader";
import { boardOf } from "@/board/boardFactory";
import { useBoardsStore } from "@/store/boards";
import { useCardStore } from "@/store/card";
import { useCategoryStore } from "@/store/category";
import { useFlexStore } from "@/store/flex";
import { useIterationStore } from "@/store/iteration";
import { useLicenseStore } from "@/store/license";
import { useLinkStore } from "@/store/link";
import { useSessionStore } from "@/store/session";
import { useStickerTypeStore } from "@/store/stickerType";
import { useStickyTypeStore } from "@/store/stickyType";
import { useTeamStore } from "@/store/team";
import { useZoomStore } from "@/store/zoom";

export function setSessionData(data: SessionData) {
  clearSessionData();
  useStickyTypeStore().stickyTypes = data.stickyTypes;
  useStickyTypeStore().almStickyTypes = data.almStickyTypes;
  useCategoryStore().categories = data.categories;
  useIterationStore().setIterations(data.boardIterations);
  if (data.boards) {
    for (const id in data.boards) {
      const board = data.boards[id];
      board.shapes.push(...boardOf(board).location(0, 0).shapes);
    }
    useBoardsStore().addBoards(data.boards);
  }
  useLinkStore().linkTypes = data.linkTypes || [];
  useLinkStore().setLinks(data.links || []);
  useFlexStore().flexTypes = data.flexTypes;
  useStickerTypeStore().setStickerTypes(data.stickerTypes);
}

export function clearStores() {
  useSessionStore().$reset();
  useLicenseStore().$reset();
  useTeamStore().$reset();
  clearSessionData();
}

function clearSessionData() {
  useZoomStore().$reset();
  useCardStore().$reset();
  useStickyTypeStore().$reset();
  useStickerTypeStore().$reset();
  useCategoryStore().$reset();
  useIterationStore().$reset();
  useBoardsStore().$reset();
  useLinkStore().$reset();
  useIterationStore().$reset();
}
